import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { collection, orderBy, query, where } from "firebase/firestore";
import { db } from "firebaseApp";
import { COLLECTIONS } from "firebaseCollections";
import { useEffect } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useDispatch, useSelector } from "react-redux";
import { documentsActions } from "store/documents";
import { editorActions } from "store/editor";
import { snapshotToArray } from "utils/react-lib/generic-ui/firebaseUtils";

export default function DocumentsLoader() {

  const dispatch = useDispatch();

  const auth = useAuth();

  const activeDocument = useSelector((state) => state.editor?.activeDocument);

  const [documentsSnap, loading, error] = useCollection(
    query(
      collection(db, COLLECTIONS.mdDocuments),
      where("uid", "==", auth.currentUser.uid),
      orderBy("createdAt", "desc")
    )
  );

  useEffect(() => {
    if (auth.currentUser) {
      const documents = snapshotToArray(documentsSnap);
      dispatch(
        documentsActions.setState({
          documents,
          loading,
          error,
        })
      );
      if(documents.length > 0 && !activeDocument) {
        dispatch(editorActions.setActiveDocument(documents[0]));
      }
    }
  }, [auth.currentUser, documentsSnap, loading, error]);

  return null;
}
